var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DsButtonGroup',{ref:"periodSelector",staticClass:"period-buttons",attrs:{"dense":"","values":_vm.periodLabelList},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }